import styled from "styled-components";

interface SpacerProps {
  axis?: string;
  size: number;
}

function getHeight({ axis, size }: SpacerProps) {
  return axis === "horizontal" ? 1 : size;
}

function getWidth({ axis, size }: SpacerProps) {
  return axis === "vertical" ? 1 : size;
}

const Spacer = styled.span`
  display: block;
  min-height: ${getHeight}px;
  min-width: ${getWidth}px;
  width: ${getWidth}px;
  height: ${getHeight}px;
`;

export default Spacer;
